module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/H78olJ/Images/cover.gif?1700065771161",
      "alt": "This image is the cover for the book Memphis Blues"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Memphis Blues\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Memphis means music. That relationship was solidified in 1909 when W. C. Handy wrote the song “Mr. Crump” and later published it as the “Memphis Blues.” As Handy’s songs were sung and played in streets and music halls, a spotlight began to shine on a new mecca for innovation in music—Memphis, Tennessee. Memphis Music: Before the Blues surveys the people, music, and events that contributed to the rich musical life that emerged against the backdrop of the Civil War and yellow fever in the 19th century. The story is not just one of the building blocks to what has been called America’s greatest export—popular music—but rather it is a story of ongoing innovation and creativity that came from a convergence of people of different cultures.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Sharp\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tim Sharp holds the Elizabeth G. Daughdrill Chair in the Fine Arts at Rhodes College in Memphis, where he administrates the Center for Outreach in the Development of the Arts and is associate dean for fine arts. Dr. Sharp conducts the Rhodes Singers and MasterSingers Chorale and teaches conducting and African American music. He is a life fellow at Clare Hall, University of Cambridge, where he continues his ongoing research on the life and music of German Moravians. The images for Memphis Music: Before the Blues come from private family collections as well as private and public libraries and archives.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0